import { getMultiSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (admin) => {
    let newErrors = {};

    if (admin.selectedDisabilities.length < 1) {
        newErrors = {
            ...newErrors,
            disabilities: { error: true, message: getMultiSelectMessage('disability') }
        };
    }

    if (admin.selectedMentalHealth.length < 1) {
        newErrors = {
            ...newErrors,
            mentalHealth: { error: true, message: getMultiSelectMessage('mental health problem') }
        };
    }

    return newErrors;
};
